<template>
	<div class="withdraw">
		<div class="fields">
			<div class="fields__item">
				<PaymentSystems v-if="types" :items="types" :selected-type="selectedType" @set-type="setType"/>
			</div>
			<div class="fields__item field-input__label" v-if="selectedType && selectedType.currency">
				<div class="field-input__label">
                    1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
                </div>
			</div>
			<div class="fields__item" v-if="selectedType?.banks?.length">
				<div class="field-input">
					<label class="field-input__label">
						Банк
					</label>
					<FieldSelect :options="selectedType.banks" placeholder="Выберите банк" @update:model-value="handlerSetBank"/>
				</div>
			</div>
            <div class="fields__item">
                <div class="field-input">
					<label class="field-input__label">
						Реквизиты
					</label>
					<input autocomplete="off" class="field-input__input" type="text" v-model="wallet" placeholder="Введите реквизиты" @input="validateSum" readonly="readonly" onfocus="this.removeAttribute('readonly');">
				</div>
            </div>
            <div class="fields__item warn-box" v-if="selectedType?.description">
                {{ selectedType.description }}
            </div>
			<div class="fields__item">
				<div class="field-input">
					<label class="field-input__label">
						Сумма  <span v-if="selectedType"> от {{ $root.currency(selectedType.min_amount) }} <span v-if="selectedType.max_amount"> до {{ $root.currency(selectedType.max_amount) }}</span></span>
						<span v-if="selectedType"><span> Комиссия: {{ selectedType.commission }}%</span></span>
					</label>
					<input autocomplete="off" class="field-input__input" type="number" v-model="amount" placeholder="Введите сумму" @input="validateSum" readonly="readonly" onfocus="this.removeAttribute('readonly');">
				</div>
			</div>
			<div class="fields__item">
				<button :disabled="!canSendWithdraw" @click="withdrawSock" class="btn btn--block">Вывести</button>
			</div>
		</div>
		<div class="withdraw__history">
			<div class="withdraw__history-title">История выводов</div>
			<template v-if="withdraws">
				<Payments :items="withdraws"/>
			</template>
		</div>
		<div class="btn"
				 @click="getMoreWithdraws"
				 v-show="page < totalPages">
			<svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" v-show="!loader">
				<circle cx="12" cy="12" r="1"></circle>
				<circle cx="19" cy="12" r="1"></circle>
				<circle cx="5" cy="12" r="1"></circle>
			</svg>
			<div class="spinner-border spinner-border-sm link-03 tx-medium tx-spacing--0 tx-10 mg-3" v-show="loader"></div>
		</div>
	</div>
</template>

<script>
    import Payments from "../../components/blocks/Payments.vue";
	import PaymentSystems from "../../components/blocks/PaymentSystems.vue";
	import FieldSelect from "../../components/blocks/FieldSelect.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';

	export default {
		components: {
			Payments,
			PaymentSystems,
			FieldSelect
		},

        data() {
            return {
                loader: false,
                amount: null,
                types: [],
                selectedType: false,
                page: 1,
                disableBtn: false,
                withdraws: [],
                totalPages: 0,
                wallet: null,
				selectedBank: null
            }
        },
        computed: {
			...mapState(useUserStore, ['user']),

            canSendWithdraw: function () {
				return this.selectedType && this.wallet && this.amount && !this.selectedType.banks.length || this.selectedType && this.wallet && this.amount && this.selectedType.banks.length && this.selectedBank;
            }
        },
        mounted() {
			setTimeout(() => {
				this.getTypes();
				this.getWithdraws();
			}, 222)
        },
        methods: {
            validateSum() {
                this.amount = this.amount.toString();
                this.amount = this.amount.replace(/[,]/g, '.').replace(/[^\d,.]*/g, '').replace(/([,.])[,.]+/g, '$1').replace(/^[^\d]*(\d+([.,]\d{0,2})?).*$/g, '$1');
            }, 
            withdrawSock() {
                this.amount = Math.round(this.amount);
                this.amount = parseInt(this.amount, 10);

                if(!this.selectedType) {
                    return this.$toast.error('Выберите способ вывода');
                }

                if(!this.amount) {
                    return this.$toast.error('Укажите сумму вывода');
                }

                if(!this.wallet) {
                    return this.$toast.error('Укажите реквизиты');
                }

                if (this.amount < this.selectedType.min_amount) {
                    return this.$toast.error(`Минимальная сумма вывода для данного способа ${this.selectedType.min_amount}`);
                }

                if (this.amount > this.selectedType.max_amount) {
                    return this.$toast.error(`Максимальная сумма вывода для данного способа ${this.selectedType.max_amount}`);
                }

                if(this.amount > this.user.balance) {
                    return this.$toast.error('На вашем балансе недостаточно средств');
                }

				if(this.selectedType.banks.length && !this.selectedBank) {
					return this.$toast.error('Необходимо выбрать банк для вывода средств');
				}

                if (this.disableBtn) {
                    return;
                }

                this.disableBtn = true;

                this.$root.axios.post('/api/withdraws', {
                    amount: this.amount,
                    type_id: this.selectedType.id,
                    wallet: this.wallet,
					bank_id: this.selectedBank
				}).then(res => {
                    this.user.balance = res.data.balance;
                    this.$toast.success(res.data.message);

                    this.amount = null;
                    this.wallet = null;
					this.selectedBank = null;
                    this.page = 1;
                    
                    this.getWithdraws();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });

                this.disableBtn = false;
            },
            getWithdraws() {
                this.loader = true;

                this.$root.axios.get('/api/withdraws', {
                    params: {
                        page: this.page
                    }   
                }).then(res => {
                    this.withdraws = this.page > 1 ? this.withdraws.concat(res.data.withdraws) : res.data.withdraws;    
                    this.totalPages = res.data.total_pages;
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });

                this.loader = false;
            },
            getTypes() {
                this.$root.axios.get('api/withdraw/types')
                .then(res => {
                    this.types = res.data;
                })
                .catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            setType(type) {
                this.selectedType = type;
				this.selectedBank = null;
            },
            getMoreWithdraws() {
                this.page += 1;
                this.getWithdraws();
            },
			handlerSetBank(bank) {
				if (bank) {
					this.selectedBank = bank.id;
				}
			}
        },
        sockets: {
            withdraw_complete: function() {
                this.page = 1;
                this.getWithdraws();
            }
        }
    }
</script>
<style scoped>
.withdraw__history {
	margin-top: 32px;
}
.withdraw__history-title {
	color: #FFF;
	font-size: 20px;
	font-weight: 500;
	line-height: 24px;
	margin-bottom: 12px;
}
</style>